import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { BRAND_ASSETS } from "../config/assets";

export default function FunnelHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 50);
      
      if (currentScrollY < 100) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };
    
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: isVisible ? 0 : -100 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white/80 backdrop-blur-xl shadow-sm" : "bg-white"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" role="navigation">
        <div className="flex items-center justify-between h-12">
          {/* Logo - Apple style: pequeño y elegante */}
          <div className="flex-shrink-0">
            <img
              src={BRAND_ASSETS.logo}
              alt="Logo"
              className="h-8 w-auto object-contain"
            />
          </div>
          
          {/* CTA Minimalista - Apple style */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => scrollToSection("#precio")}
              className="inline-flex items-center justify-center px-4 py-1.5 text-sm font-medium text-white bg-[#00C2FF] rounded-full hover:bg-[#2A1E42] transition-all duration-200 shadow-sm hover:shadow-md"
            >
              Lo Quiero
            </button>
          </div>
        </div>
      </nav>
    </motion.header>
  );
}
